import { CommonProp, generate } from '@acin/ui-core';
import React from 'react';
import { useRegTextViewer } from '../../RegTextProvider';
import { RegTextViewer } from '../../RegTextViewer';
import * as SC from './ReviewObligationsRegTextViewer.styled';

export interface ReviewObligationsRegTextViewerProps extends CommonProp {
  className?: string;
}

export const ReviewObligationsRegTextViewer: React.FC<ReviewObligationsRegTextViewerProps> = (props) => {
  const { className } = props;
  const { activeSegmentId, activeFragmentId, onToggleRegTextModal } = useRegTextViewer();

  return (
    <SC.RegTextDetail
      className={className}
      data-testid={generate(['reg-text-viewer-panel'], props)}
      defaultPosition={{ x: 0, y: 78 }}
      bounds="parent"
      onClose={onToggleRegTextModal}
    >
      <SC.TopHeading size={1}>Regulation Text</SC.TopHeading>
      <SC.Content>
        <RegTextViewer activeSegmentId={activeSegmentId} activeFragmentId={activeFragmentId} />
      </SC.Content>
    </SC.RegTextDetail>
  );
};
